import { useRouteError, isRouteErrorResponse } from 'react-router-dom'

/**
 * Last line of defence for a route that throws. Without it the router unmounts the whole tree and
 * the user gets a blank page with no way back.
 *
 * Mounted at two levels, which behave differently on purpose (see `main.tsx`): as a child route's
 * boundary it renders inside the shell and the tab bar survives, so the user can leave the broken
 * screen; as the root boundary it replaces the frame entirely, because a shell that failed or a URL
 * that matched nothing leaves no working frame to render inside. The Reload button is the only exit
 * in that second case.
 */
export function RouteError() {
  const error = useRouteError()

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Something went wrong'

  return (
    <div className="p-5 flex flex-col items-center justify-center min-h-[60vh] text-center">
      <p className="text-white text-lg font-semibold mb-2">This screen failed to load</p>
      <p className="text-white/60 text-sm mb-5 max-w-[320px] break-words">{message}</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="px-5 py-3 text-base font-semibold bg-white/15 text-white rounded-xl transition-colors hover:bg-white/25"
      >
        Reload
      </button>
    </div>
  )
}
